import React from 'react';


export default function ComingSoon() {
    return (
        <div style={{
            background: 'black',
            color: 'white',
            width: '100vw',
            height: '100vh',
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <h1 style={{fontSize: '16px'}}>Coming soon..</h1>
        </div>
    );
}